module.exports = __webpack_public_path__ + "img/whiteBrandFrontPageImg03.b5cb8659.jpg";